import { render } from "./UserProfileModalContainer.vue?vue&type=template&id=00b3e9d4&ts=true"
import script from "./UserProfileModalContainer.vue?vue&type=script&lang=ts"
export * from "./UserProfileModalContainer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__